import { Injectable } from "@angular/core";

import { LoggingLevel } from "../model/logging-level.enum";
import { environment } from "../../environments/environment";
import { Country } from "../model/country.enum";

    /**
     * @description
     *  Servicio que gestiona la configuración del entorno actual de la
     *  aplicación de manera centralizada.
     */

@Injectable({ providedIn: "root" })
export class EnvironmentService {

    constructor() {}

    public get authenticationTokenKey(): string {
        return environment.authTokenKey || "";
    }

    public get backendHost(): URL {
        return new URL(environment.API_URL || "");
    }

    public get rewardsBackendHost() : URL {
        return new URL(environment.REWARDS_API_URL || "");
    }

    public get googleMapsAPIKey(): string {
        return environment.GOOGLE_MAPS_API_KEY || "";
    }

    public get inProduction(): boolean {
        return environment.production === true || false;
    }

    public get loggingLevel(): LoggingLevel {
        return environment.loggingLevel || LoggingLevel.INFORMATION;
    }

    public get country() : Country {
        return environment.country || Country.NONE
    }
}
